import React from 'react';
import Profile from 'containers/Profile';

const ProfilePage = props => <Profile {...props} />;

ProfilePage.propTypes = {};

export default ProfilePage;
